export default "/wp-content/themes/onnit/script/cart/dist/vtiBg-b6e4a934.jpg";